/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { IContact } from "../shared/interfaces";
import { Contact_Type } from "../shared/enums";

const controller = 'Contacts';


const getContactSuggestions = (aooId: number, searchValue: string, contactType?: Contact_Type, cancelToken?: CancelToken): Promise<IContact[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetContactSuggestions`, { cancelToken: cancelToken, params: { searchValue, contactType } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getContactInfo = (aooId: number, listId: string, contactId: number, cancelToken?: CancelToken): Promise<IContact> => {
    return axiosInstance.get(`${controller}/${aooId}/GetContactInfo/${listId}/${contactId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getContactsInfoBatch = (aooId: number, listId: string, contactIds: number[], cancelToken?: CancelToken): Promise<IContact[]> => {
    return axiosInstance.post(`${controller}/${aooId}/GetContactsInfoBatch/${listId}`, contactIds, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getContactSuggestions,
    getContactInfo,
    getContactsInfoBatch
}